import Vue from 'vue'
import App from './App'
import router from './router'
import VueLazyload from 'vue-lazyload'
import { store } from './store'
import {
  NavbarPlugin,
  CardPlugin,
  ButtonPlugin,
  AlertPlugin,
  ModalPlugin,
  FormPlugin,
  FormGroupPlugin,
  LayoutPlugin,
  FormRadioPlugin,
  TablePlugin,
  FormDatepickerPlugin,
  SpinnerPlugin,
  PaginationPlugin,
  FormSelectPlugin,
  FormInputPlugin,
  VBTooltipPlugin
} from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'nprogress/nprogress.css'

// Boostrap
Vue.use(NavbarPlugin)
Vue.use(CardPlugin)
Vue.use(ButtonPlugin)
Vue.use(AlertPlugin)
Vue.use(ModalPlugin)
Vue.use(LayoutPlugin)
Vue.use(TablePlugin)
Vue.use(FormPlugin)
Vue.use(FormRadioPlugin)
Vue.use(FormGroupPlugin)
Vue.use(FormDatepickerPlugin)
Vue.use(SpinnerPlugin)
Vue.use(PaginationPlugin)
Vue.use(FormSelectPlugin)
Vue.use(FormInputPlugin)
Vue.use(VBTooltipPlugin)

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: './static/image/error.png',
  loading: './static/image/loading.gif',
  attempt: 1
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  store,
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js